module.exports = __webpack_public_path__ + "img/trash-bin-outline-blue.2eb34af5.svg";